module.exports = __webpack_public_path__ + "media/images/new/icons/rss@2x-08de611cde7b1fcb00df67ffba85e53f.png";